import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EquipementService } from "../../../services/equipement.service";
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder } from "@angular/forms";
import { CheckboxHelperService } from "../../../services/checkbox-helper.service";
import * as _ from 'lodash';
import { ToastService } from "../../../services/toast.service";
import { Router } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import { LogementService } from "../../../services/logement.service";
import { LoaderService } from "../../../services/loader.service";

@Component({
    selector: 'app-equipement-add',
    templateUrl: './equipement-add.component.html',
    styleUrls: ['./equipement-add.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquipementAddComponent implements OnInit, OnDestroy {

  /**
   * form.get() renvoie AbstractControl, qui n'expose pas `controls`. Le bloc
   * @if applique un typage strict là où *ngIf ne le faisait pas : ce cast rend
   * le FormArray explicite plutôt que de neutraliser la vérification.
   */
  asFormArray(control: AbstractControl): UntypedFormArray {
    return control as UntypedFormArray;
  }


  faPlus = faPlus;
  faSquare = faSquare;
  faCheckSquare = faCheckSquare;

  form = this.fb.group({
    equipements: this.fb.array([]),
  });

  private logementId: number = null;
  private subscription: Subscription;

  constructor(
    private logementService: LogementService,
    private equipementService: EquipementService,
    private fb: UntypedFormBuilder,
    private ch: CheckboxHelperService,
    private toastService: ToastService,
    private router: Router,
    public loaderService: LoaderService
  ) {
  }

  ngOnInit() {
    this.logementId = this.logementService.getLogementCourantId();
    this.loadEquipementsDisponibles();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private loadEquipementsDisponibles() {
    const equipements$ = this.equipementService.load(this.logementId);
    const equipementsDisponibles$ = this.equipementService.loadEquipementsIndividuelsDisponibles(this.logementId);

    this.subscription = combineLatest(equipements$, equipementsDisponibles$).subscribe(([equipements, equipementsDisponibles]) => {

      this.form.setControl('equipements', this.fb.array(this.ch.toCheckboxes(equipementsDisponibles.reduce((object, equipement) => {
        object[equipement.id] = equipement;
        return object;
      }, {}))));
      this.ch.patchValue(this.form, 'equipements', equipements.reduce((ids, equipement) => {
        if (equipement.equipement.id){
          ids.push(equipement.equipement.id.toString());
        }
        return ids;
      }, []));
      this.ch.patchDisable(this.form, 'equipements', equipements.reduce((ids, equipement) => {
        if (equipement.equipement.id){
          ids.push(equipement.equipement.id.toString());
        }
        return ids;
      }, []));
    });
  }

  save() {
    const equipements = this.form.getRawValue();
    _.set(equipements, 'equipements', this.ch.getValue(this.form, 'equipements'));
    this.equipementService.setEquipementsIndividuels(this.logementId, equipements).then(response => {
      this.toastService.show(response.message, {classname: 'toast-' + response.status});
      if (response.status != 'error') {
        this.logementService.reloadLogementCourant().then(logement => {
          this.router.navigate(['/mes-equipements']);
        });
      }
    });
  }

  toggle(item) {
    if (item.get('disabled').value) {
      return;
    }
    item.get('checked').setValue(!item.get('checked').value);
  }

}
